import React from 'react';
import './loader.component.css';

const Loader = (props) => {
  return (
    <div
      className={`loading-dots-cont ${
        props.isPageLoader ? 'fixed' : 'absolute'
      }`}
    >
      <div
        className={`loading-dots ${props.isPageLoader ? 'fixed' : 'absolute'}`}
      >
        <div className="loading-dots--dot"></div>
        <div className="loading-dots--dot"></div>
        <div className="loading-dots--dot"></div>
        <div className="loading-dots--dot"></div>
      </div>
    </div>
  );
};

export default Loader;
